import { create } from 'zustand';

interface ProfileMenuState {
	isOpen: boolean;
	setOpen: (isOpen: boolean) => void;
}

// Tracks whether the user-profile menu (the popover anchored to the
// current user's name in the navbar) is open. Lives outside the
// `useNavbarPanelsStore` because the profile menu is a Chakra `<Menu>`
// popover, not one of the mutually-exclusive side panels — and other
// surfaces (e.g. the floating dynamic-promo tile) need to react to its
// open state independently.
export const useProfileMenuStore = create<ProfileMenuState>((set) => ({
	isOpen: false,
	setOpen: (isOpen) => set({ isOpen }),
}));

export const useIsProfileMenuOpen = () => useProfileMenuStore((state) => state.isOpen);
